import type { MaintenanceStatus } from '@/types/api-response/maintenance-status-types.ts';
import { ofetch } from 'ofetch';
import { defineStore } from 'pinia';
import { ref } from 'vue';
import { attachUiSessionId } from '@/services/ui-session';

export const useMaintenanceStatusStore = defineStore('maintenanceStatus', () => {
   const isAppAccessible = ref<boolean>(true);
   const isFetched = ref<boolean>(false);

   /**
    * Check maintenance status
    */
   async function checkMaintenanceStatus() {
      try {
         const response = await ofetch<MaintenanceStatus>('/status/maintenance', {
            baseURL: import.meta.env.VITE_API_BASE_URL,
            async onRequest({ options }) {
               await attachUiSessionId(options.headers);
            },
         });

         isAppAccessible.value = !response.is_active;
         isFetched.value = true;
      }
      catch (e) {
         console.error(e);
      }
   }

   return {
      checkMaintenanceStatus,
      isAppAccessible,
      isFetched,
   };
});
